import React, { useState } from "react";
import { Row, Col, Form, Button, FormControl, Card, Dropdown } from "react-bootstrap";
import IconDropdown from '../../images/icon-download.svg'
import './index.scss';
import { AiOutlineClose } from "react-icons/ai";


const FilterBlock = ({ onApply }) => {
    const yearOptions = [
        { id: "2025", label: "2025", value: "2025" },
        { id: "2024", label: "2024", value: "2024" },
        { id: "2023", label: "2023", value: "2023" },
        { id: "2022", label: "2022", value: "2022" },
        { id: "2021", label: "2021", value: "2021" },
    ];

    const [filters, setFilters] = useState({
        search: "",
        industry: "All Industries",
        yearEnd: [],
        status: "Status",
    });

    const [yearDropdownText, setYearDropdownText] = useState("Year End");

    // const handleChange = (e) => {
    //     if (typeof e.target.value !== "string") {
    //         console.error(`Invalid value for ${e.target.name}:`, e.target.value);
    //         return;
    //     }
    //     setFilters({ ...filters, [e.target.name]: e.target.value });
    // };

    const handleChange = (e) => {
        if (typeof e.target.value !== "string") {
            console.error(`Invalid value for ${e.target.name}:`, e.target.value);
            return;
        }

        const newFilters = { ...filters, [e.target.name]: e.target.value };
        setFilters(newFilters);


        if (e.target.name === "search") {
            onApply(newFilters);
        }
    };


    const handleYearToggle = (id) => {
        let updatedYearEnd = [...filters.yearEnd];

        if (updatedYearEnd.includes(id)) {
            // Remove if already selected
            updatedYearEnd = updatedYearEnd.filter(year => year !== id);
        } else {
            // Add if not selected
            updatedYearEnd.push(id);
        }

        setFilters({ ...filters, yearEnd: updatedYearEnd });

        // Update dropdown text based on selection
        if (updatedYearEnd.length === 0) {
            setYearDropdownText("Year End");
        } else if (updatedYearEnd.length === 1) {
            const selectedYear = yearOptions.find(year => year.id === updatedYearEnd[0]);
            setYearDropdownText(selectedYear ? selectedYear.label : "Year End");
        } else {
            setYearDropdownText(`${updatedYearEnd.length} Years Selected`);
        }
    };

    const handleApply = () => {
        onApply({
            ...filters,
            yearEnd: filters.yearEnd.length > 0 ? filters.yearEnd : "Year End"
        });
    };

    const handleReset = () => {
        const resetFilters = {
            search: "",
            industry: "All Industries",
            yearEnd: [],
            status: "Status",
        };
        setFilters(resetFilters);
        setYearDropdownText("Year End");
        onApply({
            ...resetFilters,
            yearEnd: "Year End"
        });
    };

    return (
        <Form className="mb-3 credential-page client-page filter-block" onSubmit={(e) => e.preventDefault()}>
            <Card className="pt-3 px-2" style={{ border: '2px solid #ECEEF5' }}>
                <Card.Body>
                    <Row className="pb-1">
                        {/* Search Input */}
                        <Col xl={3} lg={3} md="12" className="mb-3 mb-lg-0">
                            <div style={{ position: "relative" }}>
                                <FormControl
                                    type="text"
                                    name="search"
                                    value={filters.search}
                                    onChange={handleChange}
                                    placeholder="Search"
                                    style={{ paddingRight: "30px" }}
                                />
                                {filters.search && (
                                    <AiOutlineClose
                                        onClick={() => {
                                            const reset = { ...filters, search: "" };
                                            setFilters(reset);
                                            onApply(reset);
                                        }}
                                        style={{
                                            position: "absolute",
                                            right: "10px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            cursor: "pointer",
                                            color: "#999",
                                            fontSize: "16px",
                                        }}
                                    />
                                )}
                            </div>

                        </Col>

                        <Col xl="9" lg={9} md="12">
                            <Row className="justify-content-end">
                                <Col md="2" className="my-auto d-none d-lg-none d-xl-block">
                                    <p className="my-0 fw-bold text-dark" style={{ textAlign: 'right' }}>Filters</p>
                                </Col>
                                {/* Industry Dropdown */}
                                <Col xl="3" lg={4} className="mb-3 mb-lg-0">
                                    <Form.Select name="industry" value={filters.industry} onChange={handleChange}>
                                        <option>All Industries</option>
                                        <option value="Advertising Agencies">Advertising Agencies</option>
                                        <option value="Aerospace & Defense">Aerospace & Defense</option>
                                        <option value="Agricultural Inputs">Agricultural Inputs</option>
                                        <option value="Airlines">Airlines</option>
                                        <option value="Airports & Air Services">Airports & Air Services</option>
                                        <option value="Aluminum">Aluminum</option>
                                        <option value="Apparel Retail">Apparel Retail</option>
                                        <option value="Asset Management">Asset Management</option>
                                        <option value="Auto & Truck Dealerships">Auto & Truck Dealerships</option>
                                        <option value="Auto Manufacturers">Auto Manufacturers</option>
                                        <option value="Banks - Diversified">Banks - Diversified</option>
                                        <option value="Banks - Regional">Banks - Regional</option>
                                        <option value="Beverages - Brewers">Beverages - Brewers</option>
                                        <option value="Beverages - Non-Alcoholic">Beverages - Non-Alcoholic</option>
                                        <option value="Beverages - Wineries & Distilleries">Beverages - Wineries & Distilleries</option>
                                        <option value="Biotechnology">Biotechnology</option>
                                        <option value="Building Materials">Building Materials</option>
                                        <option value="Building Products & Equipment">Building Products & Equipment</option>
                                        <option value="Capital Markets">Capital Markets</option>
                                        <option value="Chemicals">Chemicals</option>
                                        <option value="Communication Equipment">Communication Equipment</option>
                                        <option value="Computer Hardware">Computer Hardware</option>
                                        <option value="Confectioners">Confectioners</option>
                                        <option value="Congolomerates">Congolomerates</option>
                                        <option value="Consumer Electronics">Consumer Electronics</option>
                                        <option value="Copper">Copper</option>
                                        <option value="Credit Services">Credit Services</option>
                                        <option value="Diagonostics & Research">Diagonostics & Research</option>
                                        <option value="Discount Stores">Discount Stores</option>
                                        <option value="Drug Manufacturers - General">Drug Manufacturers - General</option>
                                        <option value="Drug Manufactures - Specialty & Generic">Drug Manufactures - Specialty & Generic</option>
                                        <option value="Electrical Equipment & Parts">Electrical Equipment & Parts</option>
                                        <option value="Electronic Components">Electronic Components</option>
                                        <option value="Electronic - Gaming & Multimedia">Electronic - Gaming & Multimedia</option>
                                        <option value="Engineering & Construction">Engineering & Construction</option>
                                        <option value="Entertainment">Entertainment</option>
                                        <option value="Farm & Heavy Construction Machinery">Farm & Heavy Construction Machinery</option>
                                        <option value="Financial Data & Stock Exchanges">Financial Data & Stock Exchanges</option>
                                        <option value="Footwear & Accessories">Footwear & Accessories</option>
                                        <option value="Gold">Gold</option>
                                        <option value="Healthcare Plans">Healthcare Plans</option>
                                        <option value="Home Improvement Retail">Home Improvement Retail</option>
                                        <option value="Household & Personal Products">Household & Personal Products</option>
                                        <option value="Industrial Distribution">Industrial Distribution</option>
                                        <option value="Information Technology Services">Information Technology Services</option>
                                        <option value="Insurance - Diversified">Insurance - Diversified</option>
                                        <option value="Insurance - Life">Insurance - Life</option>
                                        <option value="Insurance - Property & Casualty">Insurance - Property & Casualty</option>
                                        <option value="Insurance - Reinsurance">Insurance - Reinsurance</option>
                                        <option value="Insurance Brokers">Insurance Brokers</option>
                                        <option value="Integrated Freight & Logistics">Integrated Freight & Logistics</option>
                                        <option value="Internet Content & Information">Internet Content & Information</option>
                                        <option value="Internet Retail">Internet Retail</option>
                                        <option value="Lodging">Lodging</option>
                                        <option value="Luxury Goods">Luxury Goods</option>
                                        <option value="Medical Care Facilities">Medical Care Facilities</option>
                                        <option value="Medical Devices">Medical Devices</option>
                                        <option value="Medical Distribution">Medical Distribution</option>
                                        <option value="Medical Instruments & Supplies">Medical Instruments & Supplies</option>
                                        <option value="Oil & Gas E&P">Oil & Gas E&P</option>
                                        <option value="Oil & Gas Equipment & Services">Oil & Gas Equipment & Services</option>
                                        <option value="Oil & Gas Integrated">Oil & Gas Integrated</option>
                                        <option value="Oil & Gas Midstream">Oil & Gas Midstream</option>
                                        <option value="Other Industrial Metals & Mining">Other Industrial Metals & Mining</option>
                                        <option value="Packaged Foods">Packaged Foods</option>
                                        <option value="Railroads">Railroads</option>
                                        <option value="Real Estate - Diversified">Real Estate - Diversified</option>
                                        <option value="REIT - Industrial">REIT - Industrial</option>
                                        <option value="Restaurants">Restaurants</option>
                                        <option value="Scientific & Technical Instruments">Scientific & Technical Instruments</option>
                                        <option value="Semiconductor Equipment & Materials">Semiconductor Equipment & Materials</option>
                                    </Form.Select>
                                </Col>

                                {/* Year End Multi-Select Dropdown */}
                                <Col lg="3" className="mb-3 mb-lg-0 custom-select">
                                    <Dropdown className=" form-select" style={{ position: 'relative' }}>
                                        <Dropdown.Toggle
                                            variant="light"
                                            id="dropdown-year-end"
                                            className="w-100 text-start bg-transparent border-0"
                                            style={{ color: "#000" }}
                                        >
                                            {yearDropdownText}
                                            {/* <img src={IconDropdown} alt='i'
                                                style={{
                                                    position: 'absolute',
                                                    right: 10,
                                                    top: 14,
                                                    width: '14px'
                                                }}
                                            /> */}
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu className="w-100 ">
                                            {yearOptions.map((option) => (
                                                <div key={option.id} className="px-2 py-1 ">
                                                    <Form.Check
                                                        type="checkbox"
                                                        id={`year-${option.id}`}
                                                        label={option.label}
                                                        checked={filters.yearEnd.includes(option.id)}
                                                        onChange={() => handleYearToggle(option.id)}
                                                    />
                                                </div>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Col>

                                {/* Status Dropdown */}
                                <Col xl="2" lg={3} className="mb-3 mb-lg-0">
                                    <Form.Select name="status" value={filters.status} onChange={handleChange}>
                                        <option>Status</option>
                                        <option value="Active">Active</option>
                                        <option value="InActive">In-Active</option>
                                    </Form.Select>
                                </Col>

                                {/* Buttons */}
                                <Col lg="2" className="d-flex gap-2">
                                    <Button variant="primary" className="w-100" onClick={handleApply}>Apply</Button>
                                </Col>
                            </Row>
                        </Col>
                        <div className="d-flex justify-content-end">
                            <p className="my-0 fw-bold text-primary w-auto" style={{ textAlign: 'right', cursor: 'pointer' }} onClick={handleReset} >
                                Reset
                            </p>
                        </div>

                    </Row>
                </Card.Body>
            </Card>
        </Form>
    );
};

export default FilterBlock;
